export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-960-7487c0871efba1f1400436c326ed5680.png";